"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _AvatarImage = _interopRequireDefault(require("../avatar/AvatarImage"));

var _avatarConstants = require("../avatar/avatarConstants");

var _context = require("../context");

var _layout = require("../layout");

var _text = require("../text");

var _utils = require("../utils");

var _ChipAvatarLink = _interopRequireDefault(require("./ChipAvatarLink"));

var _ChipDismissButton = _interopRequireDefault(require("./ChipDismissButton"));

var _constants = require("./constants");

var _interfaces = require("./interfaces");

var _useChipStyle2 = _interopRequireDefault(require("./useChipStyle"));

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ChipBase = function ChipBase(props) {
  var avatar = props.avatar,
      children = props.children,
      _props$size = props.size,
      size = _props$size === void 0 ? _interfaces.ChipSize.Default : _props$size,
      icon = props.icon,
      _props$iconPosition = props.iconPosition,
      iconPosition = _props$iconPosition === void 0 ? _interfaces.ChipIconPosition.Leading : _props$iconPosition,
      onClick = props.onClick,
      onDismiss = props.onDismiss,
      _props$colorScheme = props.colorScheme,
      colorScheme = _props$colorScheme === void 0 ? _interfaces.ChipColorScheme.Default : _props$colorScheme,
      dismissButtonRef = props.dismissButtonRef,
      _props$dismissButtonA = props.dismissButtonAltText,
      dismissButtonAltText = _props$dismissButtonA === void 0 ? 'Remove' : _props$dismissButtonA,
      _props$backgroundColo = props.backgroundColor,
      backgroundColorProp = _props$backgroundColo === void 0 ? _interfaces.ChipBackgroundColor.Default : _props$backgroundColo;

  var _useContext = (0, _react.useContext)(_context.StencilContext),
      selectors = _useContext.selectors;

  var chipId = "chip-".concat((0, _utils.getUniqueId)(), "-id");
  var isDismissible = typeof onDismiss === 'function';
  var asAvatar = Boolean(avatar);

  var _useChipStyle = (0, _useChipStyle2.default)({
    size: size,
    icon: icon,
    iconPosition: iconPosition,
    colorScheme: colorScheme,
    backgroundColor: backgroundColorProp,
    asAvatar: asAvatar,
    isDismissible: isDismissible
  }),
      containerPadding = _useChipStyle.containerPadding,
      textPadding = _useChipStyle.textPadding,
      avatarImageSize = _useChipStyle.avatarImageSize,
      fontSize = _useChipStyle.fontSize,
      hasLeadingIcon = _useChipStyle.hasLeadingIcon,
      hasTrailingIcon = _useChipStyle.hasTrailingIcon;

  var avatarImageSource = avatar ? "".concat(_avatarConstants.BADGE_PHOTO_URL, "?uid=").concat(avatar.username) : '';
  return (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    width: "max-content",
    maxWidth: "100%",
    gridGap: _constants.CHIP_CONTENT_GAP,
    padding: containerPadding
  }, avatar && (0, _core.jsx)(_AvatarImage.default, {
    selectors: selectors,
    size: avatarImageSize,
    source: avatarImageSource,
    shouldAnnounceImageAltText: false,
    marginRight: 0
  }), !avatar && hasLeadingIcon && icon, (0, _core.jsx)(_layout.Row, {
    alignItems: "center",
    padding: textPadding,
    gridGap: _constants.AVATAR_USERNAME_GAP
  }, (0, _core.jsx)(_text.Text, {
    fontSize: fontSize,
    id: isDismissible ? chipId : undefined
  }, avatar ? "".concat(avatar.fullName, " ") : children), avatar && (0, _core.jsx)(_ChipAvatarLink.default, {
    username: avatar.username,
    newTabHiddenText: avatar.newTabHiddenText || _avatarConstants.AvatarDefaultProps.newTabHiddenText,
    fontSize: fontSize,
    colorScheme: colorScheme,
    isClickable: avatar.isUsernameClickable
  })), !avatar && !isDismissible && hasTrailingIcon && icon, onDismiss && !onClick && (0, _core.jsx)(_ChipDismissButton.default, {
    chipId: chipId,
    dismissButtonRef: dismissButtonRef,
    dismissButtonAltText: dismissButtonAltText,
    onDismiss: onDismiss,
    colorScheme: colorScheme
  }));
};

var _default = ChipBase;
exports.default = _default;